import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=9f7cd760&scoped=true&"
import script from "./Base.vue?vue&type=script&lang=js&"
export * from "./Base.vue?vue&type=script&lang=js&"
import style0 from "styles/views/account/base.css?vue&type=style&index=0&id=9f7cd760&scoped=true&lang=css&"
import style1 from "./Base.vue?vue&type=style&index=1&id=9f7cd760&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7cd760",
  null
  
)

export default component.exports